import request from '@/utils/request'

let ServicesApi = {

    userlist(data) {
        return request._post('/shop/plus.services.Index/index', data);
    },

  /*删除司机*/
      deleteuser(data) {
        return request._post('/shop/user.user/delete', data);
  },

  calculateRebate(data) {
    return request._post('/shop/plus.saler.Index/calculateRebate', data);
},
getRebateList(data) {
    return request._post('/shop/plus.saler.Index/getRebateList', data);
},



/*添加业务员*/
add(data) {
    return request._post('/shop/plus.saler.Index/add', data);
},
/*修改业务员*/
edit(data) {
    return request._post('/shop/plus.saler.Index/edit', data);
},
/*删除业务员*/
del(data) {
    return request._post('/shop/plus.saler.Index/del', data);
},
/*业务员详情*/
detail(data) {
  return request._post('/shop/plus.saler.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.saler.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.saler.Setting/getSetting', data, errorback);
    },
}
export default ServicesApi;



// WEBPACK FOOTER //
// ./src/api/services.js